import React from 'react'
import type { Icon } from 'shared/utils'

const CircleJobs = (props: Icon) => {
    const { color = 'white', size = 80, className = 'circle-jobs' } = props

    return (
        <svg width={size} height={size} className={className}>
            <g fill={color} fillRule="evenodd">
                <path
                    d="M40 77c20.435 0 37-16.565 37-37S60.435 3 40 3 3 19.565 3 40s16.565 37 37 37zm0 3C17.909 80 0 62.091 0 40S17.909 0 40 0s40 17.909 40 40-17.909 40-40 40z"
                    fillRule="nonzero"
                />
                <path d="M33.702 25.61c0-.801.652-1.454 1.453-1.454h9.69c.801 0 1.454.653 1.454 1.454v2.907H33.702V25.61zm24.224 2.907h-8.72V25.61a4.365 4.365 0 0 0-4.361-4.36h-9.69a4.365 4.365 0 0 0-4.36 4.36v2.907h-8.721a2.907 2.907 0 0 0-2.907 2.907v23.178a2.907 2.907 0 0 0 2.906 2.907h35.854a2.907 2.907 0 0 0 2.906-2.907V31.424a2.906 2.906 0 0 0-2.907-2.907z" />
            </g>
        </svg>
    )
}

export { CircleJobs }
